import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

import { useSelector } from 'react-redux';
import { RootState } from '../application/store';
import { BVErrorPage } from '../common/components/BVErrorPage/bv-error-page';
import LoginPage from '../pages/LoginPage/login-page';

export const withAuthentication =
	(WrappedComponent: any, needAdmin?: boolean) => (props: any) => {
		const { inProgress } = useMsal();
		const isAdmin = useSelector((state: RootState) => state.system.isAdmin);

		const isAuthenticated = useIsAuthenticated();

		if (!isAuthenticated) {
			if (
				inProgress !== InteractionStatus.Startup &&
				inProgress !== InteractionStatus.HandleRedirect
			) {
				return <LoginPage {...props} />;
			}
			return null;
		}

		if (needAdmin) {
			return isAdmin ? (
				<WrappedComponent {...props} />
			) : (
				<BVErrorPage
					errorCode={403}
					errorMessage="You are not authorized to enter this page!"
				/>
			);
		}
		return isAuthenticated ? <WrappedComponent {...props} /> : null;
	};
